<div
  class="flex justify-center items-center mt-5 lg:mt-0 ml-5 mr-5 flex-col lg:flex-row h-full"
>
  <mat-card class="w-fit text-center">
    <div class="flex flex-row items-center">
      <div class="h-full flex flex-col">
        <mat-card-header class="w-full justify-center">
          <mat-card-title class="mb-10">Review New Vendor</mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="flex justify-self-center mt-2 w-2/3 mb-4">
            Please review the following vendor and give the approval or rejection below.
          </div>

          @if (alreadyReviewed) {
            <mat-error class="mb-4">
              This Vendor has already been reviewed, but you can override it below.
            </mat-error>
          }

          <form [formGroup]="reviewVendorForm" class="flex flex-col">
            <mat-form-field>
              <mat-label> Name</mat-label>
              <input
                matInput
                type="text"
                formControlName="name"
                placeholder="Name"
                maxlength=""
                [readonly]="true"
              />
            </mat-form-field>

            <mat-form-field>
              <mat-label> Email </mat-label>
              <input
                matInput
                type="text"
                formControlName="email"
                placeholder="Email"
                maxlength=""
                [readonly]="true"
              />
            </mat-form-field>

            <mat-form-field>
              <mat-label> First Name </mat-label>
              <input
                matInput
                type="text"
                formControlName="firstName"
                placeholder="First Name"
                maxlength=""
                [readonly]="true"
              />
            </mat-form-field>

            <mat-form-field>
              <mat-label> Last Name </mat-label>
              <input
                matInput
                type="text"
                formControlName="lastName"
                placeholder="Last Name"
                maxlength=""
                [readonly]="true"
              />
            </mat-form-field>

            <mat-form-field>
              <mat-label> Phone </mat-label>
              <input
                matInput
                type="text"
                formControlName="phone"
                [readonly]="true"
              />
            </mat-form-field>

            <mat-form-field>
              <mat-label> Student Ambassador </mat-label>
              <input
                matInput
                type="text"
                formControlName="studentAmbassador"
                placeholder="Student Ambassador"
                maxlength=""
                [readonly]="true"
              />
            </mat-form-field>
          </form>

          <div class="flex flex-row button-contiainer w-full justify-end">
            <app-menu-button [options]="menuButtonOptions" color="accent" [(value)]="menuOptionSelected" (onClick)="onActionClicked()"></app-menu-button>
          </div>
        </mat-card-content>
      </div>
    </div>
  </mat-card>
</div>
